import { render, staticRenderFns } from "./OrderPickup.vue?vue&type=template&id=19194663&scoped=true"
import script from "./OrderPickup.vue?vue&type=script&lang=js"
export * from "./OrderPickup.vue?vue&type=script&lang=js"
import style0 from "./OrderPickup.vue?vue&type=style&index=0&id=19194663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19194663",
  null
  
)

export default component.exports